module.exports = __webpack_public_path__ + "static/img/images01.efeb6fd8.jpg";